import axios from "axios";

//cria a base da api que será utilizada
const api = axios.create({
  // baseURL: "http://localhost:8081/api",
  baseURL: "https://ninoedu.labcct.net.br/api",
});

export default api;
